export default function PageLoader() {
	return (
		<main className="fixed inset-0 z-50 h-screen flex items-center justify-center overflow-auto p-8 bg-[#fafafa]">
			<div className="max-w-[960px] mx-auto flex flex-col items-center gap-4">
				<div className="pulse-loader">
					<img src="/images/sayaboutus-logomark-light.svg" alt="Say About Us" className="w-16 h-16" />
				</div>
			</div>

			<style>{`
				@keyframes pulse {
					0%, 100% {
						opacity: 1;
						transform: scale(1);
					}
					50% {
						opacity: 0.6;
						transform: scale(0.92);
					}
				}
				
				.pulse-loader {
					animation: pulse 1.5s ease-in-out infinite;
				}
			`}</style>
		</main>
	);
}
